import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreatePricingPlanCap } from 'src/features/pricingPlan/api/caps/useCreatePricingPlanCap';
import { LIST_PRICING_PLAN_CAPS_RESOURCE } from 'src/features/pricingPlan/api/caps/useListPricingPlanCaps';
import CapFormModal from 'src/features/pricingPlan/components/form/caps/CapFormModal';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface CapFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateTierFormModal<TData>({ className, semantics }: CapFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { planId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreatePricingPlanCap({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PRICING_PLAN_CAPS_RESOURCE] });
            toast({
                title: formatMessage(pricingPlanMessages.createCapSuccess),
                description: formatMessage(pricingPlanMessages.createCapSuccessDescription),
            });
        },
    });

    return (
        <CapFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ planId, parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(pricingPlanMessages.createCapSubtitle)}
        />
    );
}

export default CreateTierFormModal;
